export default "__VITE_ASSET__DH17fcb1__"